// extracted by mini-css-extract-plugin
module.exports = {"TopNavigation":"TopNavigation_TopNavigation__2DL4l"};